export default __webpack_public_path__ + "static/media/arrow.287537e1.svg";